import PropTypes from "prop-types";
import {  Typography, Badge} from "@mui/material";
import { ScopeGuard } from "../../../reusable-components/scopes";
import { useHeaderItems } from "../headerItems";

export default function HeaderItems() {
  const HeaderTypography = ({item}) => <Typography
    sx={{ ml: 2, cursor: 'pointer' }}
    variant="subtitle1"
    color={item.color}
    onClick={item.onClick}
  >
    {item.label}
  </Typography>

  HeaderTypography.propTypes = {
    item: PropTypes.shape({
      color: PropTypes.string,
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
    }).isRequired,
  };

  const { headerItems } = useHeaderItems();

  return <>
    {headerItems.map(item => item.scopes?.length && item.badge ? 
      <ScopeGuard scopes={item.scopes} allowAdmin={item.allowAdmin} key={item.label}>
        <Badge
          badgeContent={item.badgeContent}
          color="info"
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          sx={{
            '& .MuiBadge-badge': {
              right: 0,
              top: -2,
              border: '2px solid #fff',
              padding: '0 4px',
            },
          }}
        >
          <HeaderTypography item={item}/>
        </Badge>
      </ScopeGuard> : item?.scopes?.length ?
      <ScopeGuard scopes={item.scopes} allowAdmin={item.allowAdmin} key={item.label}>
        <HeaderTypography item={item}/>
      </ScopeGuard> : <HeaderTypography key={item.label} item={item}/>
    )}
  </>
}